var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Edit Charge"},on:{"on-hide":_vm.resetFormData}},[_c('recurring-charge-form',_vm._b({key:_vm.formKey,attrs:{"new-form":false,"frequency-options":_vm.frequencyOptions},on:{"on-submit":_vm.update,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'recurring-charge-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }